import { register, start, navigate } from './router.js';
import { api } from './api.js';
import { initShell } from './lib/shell.js';
import { initHeaderSearch } from './lib/header-search.js';
import { renderEnvBadge } from './lib/env-badge.js';
import { render as renderDashboard } from './screens/dashboard.js';
import { render as renderThemes } from './screens/themes.js';
import { render as renderScores } from './screens/scores.js';
import { renderList as renderAchievementList, renderDetail as renderAchievementDetail } from './screens/achievements.js';
import { render as renderAnalytics } from './screens/analytics.js';
import { render as renderMemory } from './screens/memory.js';
import { renderList as renderModerationList, renderDetail as renderModerationDetail } from './screens/moderation.js';
import { renderList as renderContactList, renderDetail as renderContactDetail } from './screens/contact.js';
import { renderList as renderReportList, renderDetail as renderReportDetail } from './screens/reports.js';
import { renderList as renderClientErrorList, renderDetail as renderClientErrorDetail } from './screens/client-errors.js';
import { render as renderUsers } from './screens/users.js';
import { renderDetail as renderUserDetail } from './screens/user-detail.js';
import { render as renderGames } from './screens/games.js';
import { render as renderIntegrations } from './screens/integrations.js';
import { renderFeatureFlags } from './screens/feature-flags.js';
import { renderRooms } from './screens/rooms.js';
import { renderDatabase } from './screens/database.js';
import { render as renderOgPreview } from './screens/og-preview.js';
import { renderList as renderNewsList, renderDetail as renderNewsDetail } from './screens/news.js';
import { installArtworkCoverRecoveryLayer } from '../../../src/shared/components/artwork-image.js';

installArtworkCoverRecoveryLayer(globalThis.document);
initShell();
initHeaderSearch(navigate);

// The 4th argument is route metadata { group, title, action? } (spec §4). `group`
// is the header breadcrumb eyebrow, `title` the screen title; the topbar action
// slot is left empty for these screens (their actions remain inline) and is
// reset on every navigation by the router. Groups mirror the six sidebar groups.
register('/admin',                         'dashboard',         renderDashboard,        { group: 'Overview',      title: 'Dashboard' });
register('/admin/users',                   'users',             renderUsers,            { group: 'Community',     title: 'Users' });
register('/admin/users/:id',               'user-detail',       renderUserDetail,       { group: 'Community',     title: 'User Detail' });
register('/admin/themes',                  'themes',            renderThemes,           { group: 'Content',       title: 'Themes' });
register('/admin/scores',                  'scores',            renderScores,           { group: 'Insights',      title: 'Scores' });
register('/admin/achievements',            'achievements',      renderAchievementList,  { group: 'Insights',      title: 'Achievements' });
register('/admin/achievements/:id',        'achievements-detail', renderAchievementDetail, { group: 'Insights',   title: 'Achievement detail' });
register('/admin/games',                   'games',             renderGames,            { group: 'Insights',      title: 'Top Games' });
register('/admin/analytics',               'analytics',         renderAnalytics,        { group: 'Insights',      title: 'Analytics' });
register('/admin/memory',                  'memory',            renderMemory,           { group: 'System Health', title: 'Memory' });
register('/admin/moderation',              'moderation',        renderModerationList,   { group: 'Community',     title: 'Moderation' });
register('/admin/moderation/events/:id',   'moderation-detail', renderModerationDetail, { group: 'Community',     title: 'Event Detail' });
register('/admin/reports',                 'reports',           renderReportList,       { group: 'Community',     title: 'Reports' });
register('/admin/reports/:id',             'reports-detail',    renderReportDetail,     { group: 'Community',     title: 'Report Detail' });
register('/admin/contact',                 'contact',           renderContactList,      { group: 'Community',     title: 'Contact' });
register('/admin/contact/:id',             'contact-detail',    renderContactDetail,    { group: 'Community',     title: 'Submission' });
register('/admin/client-errors',           'client-errors',     renderClientErrorList,  { group: 'System Health', title: 'Client Errors' });
register('/admin/client-errors/:id',       'client-errors-detail', renderClientErrorDetail, { group: 'System Health', title: 'Error Detail' });
register('/admin/rooms',                   'rooms',             renderRooms,            { group: 'System Health', title: 'Active Rooms' });
register('/admin/database',                'database',          renderDatabase,         { group: 'System Health', title: 'Database' });
register('/admin/feature-flags',           'feature-flags',     renderFeatureFlags,     { group: 'Configuration', title: 'Feature Flags' });
register('/admin/systems',                 'feature-flags',     (p, ctx) => renderFeatureFlags(p, { ...ctx, scrollTo: '#ff-systems' }), { group: 'Configuration', title: 'Systems' });
register('/admin/integrations',            'integrations',      renderIntegrations,     { group: 'Configuration', title: 'Integrations' });
register('/admin/og-preview',              'og-preview',        renderOgPreview,        { group: 'Content',       title: 'OG Cards' });
register('/admin/news',                    'news',              renderNewsList,         { group: 'Content',       title: 'News' });
register('/admin/news/:id',                'news-detail',       renderNewsDetail,       { group: 'Content',       title: 'Edit News' });

async function boot() {
  const splash = document.getElementById('admin-splash');

  try {
    const res = await fetch('/api/admin/check', { credentials: 'include' });
    if (!res.ok) { window.location.replace('/'); return; }
    const check = await res.json();
    if (!check.isAdmin) { window.location.replace('/'); return; }
  } catch {
    window.location.replace('/');
    return;
  }

  if (splash) splash.hidden = true;
  document.querySelector('.app').hidden = false;
  renderEnvBadge(location.hostname);
  start();
}

boot();
